var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26030_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 7.99996C9.47317 7.99996 10.6665 6.80663 10.6665 5.33329C10.6665 3.85996 9.47317 2.66663 7.99984 2.66663C6.5265 2.66663 5.33317 3.85996 5.33317 5.33329C5.33317 6.80663 6.5265 7.99996 7.99984 7.99996ZM7.99984 9.33329C6.21984 9.33329 2.6665 10.2266 2.6665 12V13.3333H13.3332V12C13.3332 10.2266 9.77984 9.33329 7.99984 9.33329Z",
    fill: "#9D9DE3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26030_877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.a1c72233.svg";
export { ForwardRef as ReactComponent };